import { FieldValue, fieldControlClass, fieldDescribedBy } from "./FieldValue";
import { NumberFieldProps } from "./NumberField.types";

const StepButton =
  "btn p-0 w-32 h-32 border rounded-2 bg-white text-body-secondary d-flex align-items-center justify-content-center flex-shrink-0";

/** Number (`int`) editable field. */
export function NumberField({
  label,
  name,
  value,
  onChange,
  disabled,
  required,
  error,
  className,
  placeholder,
  helpText,
  stepper,
}: NumberFieldProps) {
  const current = value ?? 0;
  const step = (next: number) => onChange(Math.max(0, next));

  return (
    <FieldValue label={label} htmlFor={name} required={required} helpText={helpText} error={error} className={className}>
      {stepper ? (
        <div className="d-flex align-items-center gap-1">
          <button
            type="button"
            className={StepButton}
            aria-label={`Decrease ${label}`}
            disabled={disabled || current <= 0}
            onClick={() => step(current - 1)}
          >
            &minus;
          </button>
          <input
            id={name}
            aria-describedby={fieldDescribedBy(name, helpText, error)}
            aria-invalid={error ? true : undefined}
            name={name}
            type="text"
            inputMode="numeric"
            className={fieldControlClass("form-control form-control-sm text-center px-1 w-40 h-32", error)}
            value={value ?? ""}
            placeholder="0"
            disabled={disabled}
            onChange={(event) => {
              const digits = event.target.value.replace(/\D/g, "");

              onChange(digits === "" ? null : Number(digits));
            }}
          />
          <button
            type="button"
            className={StepButton}
            aria-label={`Increase ${label}`}
            disabled={disabled}
            onClick={() => step(current + 1)}
          >
            +
          </button>
        </div>
      ) : (
      <input
        id={name}
        aria-describedby={fieldDescribedBy(name, helpText, error)}
        aria-invalid={error ? true : undefined}
        name={name}
        type="number"
        className={fieldControlClass("form-control", error)}
        value={value ?? ""}
        onChange={(event) =>
          onChange(event.target.value === "" ? null : Number(event.target.value))
        }
        placeholder={placeholder}
        disabled={disabled}
        required={required}
      />
      )}
    </FieldValue>
  );
}
